var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 100,
    viewBox: "0 0 162 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 10.6992H59.0098V89.3076H102.844V10.6992Z",
    fill: "#FFDE6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9261 50C61.9261 34.0291 69.448 19.8544 80.9903 10.6958C72.4957 4.02913 61.7802 0 50.0921 0C22.4036 0 0 22.3625 0 50C0 77.6375 22.4036 100 50.0921 100C61.7802 100 72.4957 95.9709 80.9903 89.3042C69.4318 80.2751 61.9261 65.9709 61.9261 50Z",
    fill: "#FBCE30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.984 50C161.984 77.6375 139.581 100 111.892 100C100.204 100 89.4887 95.9709 80.9941 89.3042C92.6823 80.1295 100.058 65.9709 100.058 50C100.058 34.0291 92.5364 19.8544 80.9941 10.6958C89.4725 4.02913 100.188 0 111.876 0C139.581 0 161.984 22.5081 161.984 50Z",
    fill: "#FBCE30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.f5c1f627152b5a146548d3f373d2fb58.svg";
export { ForwardRef as ReactComponent };